import React, { useState } from 'react';
import './AddDriverModal.css';

const AddDriverModal = ({ isOpen, onClose, onAddDriver }) => {
  if (!isOpen) return null;

  const handleAddDriver = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('full_name', event.target.full_name.value);
    formData.append('document', event.target.document.value);
    formData.append('id_organization', event.target.id_organization.value);
    formData.append('id_vehicles', event.target.id_vehicles.value);
    formData.append('id_division', event.target.id_division.value);
    onAddDriver(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Добавить водителя</h2>
        <form onSubmit={handleAddDriver}>
          <div>
            <label htmlFor="full_name">Полное имя:</label>
            <input type="text" id="full_name" name="full_name" required />
          </div>
          <div>
            <label htmlFor="document">Документ:</label>
            <input type="text" id="document" name="document" required />
          </div>
          <div>
            <label htmlFor="id_organization">ID Организации:</label>
            <input type="number" id="id_organization" name="id_organization" required />
          </div>
          <div>
            <label htmlFor="id_vehicles">ID Транспортного средства:</label>
            <input type="number" id="id_vehicles" name="id_vehicles" required />
          </div>
          <div>
            <label htmlFor="id_division">ID Подразделения:</label>
            <input type="number" id="id_division" name="id_division" required />
          </div>
          <button type="submit">Добавить</button>
          <button type="button" onClick={onClose}>Отмена</button>
        </form>
      </div>
    </div>
  );
};

export default AddDriverModal;
